import { SettingsGroupCard, SettingsHubPage, SettingsNavItem } from '../settings-shared';

export function SettingsDevelopmentPage() {
  return (
    <SettingsHubPage title="Разработка">
      <SettingsGroupCard title="Мониторинг">
        <SettingsNavItem title="Логи анализа" subTitle="Последние запуски" to="/settings/analyzer-logs" isLast />
      </SettingsGroupCard>
    </SettingsHubPage>
  );
}
